import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, getcountries} from '../../../services/admin/abstractReceipt/abReviewersServices';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';


const ApprovedReviewers = () => {
  const [dataList, setDataList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  //filter
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [seriesFilter, setSeriesFilter] = useState('');
  const [subDomainFilter, setSubDomainFilter] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const [dropdownData, setDropdownData] = useState({
      countries: []
  }); 
  
  // Fetch data
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({ approval: 1 });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

   // Fetch all dropdown data
  const fetchDropdownData = useCallback(async () => {
    try {
      const [country] = await Promise.all([
        getcountries(),            
      ]);
  
      setDropdownData({
        countries: country,
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }, []);

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      await fetchDropdownData();
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
  }, [fetchData, fetchDropdownData]);

 
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };
  
  // Memoized filtered data based on search query
    const filteredData = useMemo(() => {
    const startDateObj = startDate ? new Date(startDate) : null;
    const endDateObj = endDate ? new Date(endDate) : null;
    
        return dataList
          .filter((data) => {
            const matchesText =
              data.reviewer_name.toLowerCase().includes(searchText.toLowerCase()) ||
              data.sub_domain.toLowerCase().includes(searchText.toLowerCase());
    
            const date = new Date(data.updatedAt);
    
            // If both startDate and endDate are provided, filter by date range
            const inRange = (startDateObj && endDateObj) 
              ? date >= startDateObj && date <= endDateObj 
              : true; // Otherwise, no date filtering
    
            // Other filters (series, subDomain, country)
            const matchSeries = !seriesFilter || data.series === seriesFilter;
            const matchSubDomain = !subDomainFilter || data.sub_domain === subDomainFilter;
            const matchCountry = !countryFilter || data.reviewer_country === countryFilter;
    
            return matchesText && inRange && matchSubDomain && matchCountry && matchSeries;
          })
          .sort((a, b) => {
            // If both startDate and endDate are selected, sort the data by date
            if (startDateObj && endDateObj) {
              return new Date(b.updatedAt) - new Date(a.updatedAt); // Sort descending
            }
            return 0; // No sorting if dates are not set
          });
    }, [dataList, searchText, subDomainFilter, seriesFilter, countryFilter, startDate, endDate]);
       
  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '10%',
    },
    {
        name: 'SubDomain',
        selector: (row) => row.sub_domain,
        sortable: true,
        width: '15%',
        wrap: true
    },
    {
    name: 'Series',
    selector: (row) => {
      // Assuming the `series` field is in format like "2025-11" or "2025-11-15"
      const date = new Date(row.series);
      
      // Format as "2025-11 Nov 2025"
      const year = date.getFullYear();
      const month = date.getMonth(); // 0-based index, so we add 1
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      
      return ` ${months[month]} ${year}`;
    },
    sortable: true,
    width: '15%',
    wrap: true

   },
    {
      name: 'Name',
      selector: (row) => row.reviewer_name,
      sortable: true,
      width: '15%',
      wrap: true
    },
    {
      name: 'Country',
      selector: (row) => getCountryName(row.reviewer_country || 'N/A'),
      sortable: true,
      width: '15%',
      wrap: true
    },
    {
            name: 'Signature',
            selector: (row) => (
                <img
                  src={row.reviewer_signature}
                  width="100"
                  alt={row.reviewer_affiliation}
                />
              ),
            sortable: false,
            width: '15%',
            wrap: true
    },
    {
        name: 'Status',
        cell: (row) => (
          <span className={`badge ${Number(row.status) === 1 ? 'bg-success' : 'bg-danger'}`}>
            {Number(row.status) === 1 ? 'Active' : 'Inactive'}
          </span>
        ),
        sortable: true,
        width: '10%',
        wrap: true

      },
  ];
  // Function to render expandable row details
  const ExpandableRow = ({ data }) => {
    return (
      <div className="p-3 bg-light border">
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td><b>Reviewer Affilation:</b></td>
              <td>{data.reviewer_affiliation}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
                <div className=" row m-3 d-flex flex-column gap-3 ">
          <div className="d-flex gap-2">
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Series</span>
              <select className="form-control" value={seriesFilter} onChange={(e) => setSeriesFilter(e.target.value)}>
                <option value="">All Series</option>
                {Array.from(new Set(dataList.map(item => item.series))).sort((a, b) => b.localeCompare(a)).map((series, idx) => (
                  <option key={idx} value={series}>{series}</option>
                ))}
              </select>
            </div>
            {/* Dropdown for Filters */}
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Sub Domain</span>
              <select className="form-control" value={subDomainFilter} onChange={(e) => setSubDomainFilter(e.target.value)}>
                <option value="">All Subdomains</option>
                {Array.from(new Set(dataList.map(item => item.sub_domain))).sort((a,b)=>a.localeCompare(b)).map((subDomain, idx) => (
                  <option key={subDomain} value={subDomain}>{subDomain}</option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
            <span className='fs-5 text-dark'>Countries</span>
            <select
              className="form-control"
              value={countryFilter}
              onChange={(e) => setCountryFilter(e.target.value)}
            >
              <option value="">All Countries</option>
              {dropdownData.countries.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>

            {/* Start Date and End Date Input */}
            <div className="col-md-2">
              <span className='fs-5 text-dark'>Start Date</span>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <span className='fs-5 text-dark'>End Date</span>
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div> 
        </div>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className="fs-4 fs-5 text-dark">PDF Generation / Abstract Receipt / Reviewer / Approved Reviewers</p>
            </div>

          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText} onChange={handleSearchChange} />
              </div>
            }
            expandableRows
            expandableRowsComponent={ExpandableRow}  // ✅ Adding expandable row
          />
        </div>
        <Footer />
        </div>
        )};
      </div>
    </div>
  );
};

export default ApprovedReviewers;
